export default "__VITE_ASSET__DfFxpW8O__"